import React from "react";
import { ShieldCheck, BrainCircuit } from "lucide-react";

const LegalBanner = () => {
  return (
    <div className="bg-[rgb(218,255,1)] text-[rgb(17,17,19)] py-3 px-4 border-b border-[rgba(0,0,0,0.1)]">
      <div className="max-w-[1200px] mx-auto flex flex-col md:flex-row items-center justify-between gap-2 text-center md:text-left">
        <div className="flex items-center gap-2">
          <BrainCircuit size={18} className="text-[rgb(17,17,19)]" />
          <span
            className="text-[10px] md:text-xs font-bold tracking-[0.15em] uppercase"
            style={{ fontFamily: "'Inter', sans-serif" }}
          >
            100% Human-Composed & Executed // Zero Generative AI. Fully secured for B2B Sync Licensing.
          </span>
        </div>
        <div className="flex items-center gap-2">
          <ShieldCheck size={18} className="text-[rgb(17,17,19)]" />
          <span
            className="text-[10px] md:text-xs font-medium tracking-[0.05em]"
            style={{ fontFamily: "'Inter', sans-serif" }}
          >
            All assets are 200% One-Stop (Master & Publishing). Fully cleared. BMI Registered.
          </span>
        </div>
      </div>
    </div>
  );
};

export default LegalBanner;
